import { render, staticRenderFns } from "./PackageDetailInfo.vue?vue&type=template&id=30aca132&scoped=true"
import script from "./PackageDetailInfo.vue?vue&type=script&lang=js"
export * from "./PackageDetailInfo.vue?vue&type=script&lang=js"
import style0 from "./PackageDetailInfo.vue?vue&type=style&index=0&id=30aca132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30aca132",
  null
  
)

export default component.exports